export * from './lib/primeng/primeng.module';
